const escapeSelector = (value) => {
  if (window.CSS?.escape) {
    return window.CSS.escape(value);
  }

  return value.replace(/([ #;?%&,.+*~\':"!^$\[\]()=>|\/@])/g, '\\$1');
};

const getCollapseElementFromHash = (accordionRoot, hashValue) => {
  if (!hashValue) {
    return null;
  }

  const target = accordionRoot.querySelector(`#${escapeSelector(hashValue)}`);

  if (!target) {
    return null;
  }

  if (target.classList.contains('accordion-collapse')) {
    return target;
  }

  return target.querySelector('.accordion-collapse');
};

const openPanel = (collapseElement) => {
  const collapseApi = window.bootstrap?.Collapse;

  if (!collapseApi) {
    return;
  }

  collapseApi.getOrCreateInstance(collapseElement, { toggle: false }).show();
};

const scrollToAccordionHeader = (parentItem, behavior = 'smooth') => {
  const header = parentItem.querySelector('.accordion-header');
  const target = header ?? parentItem;
  const offset = 80;
  const top = target.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({ top, behavior });
};

export const initInfoStageCategoryAccordion = () => {
  const accordionRoot = document.querySelector('[data-info-stage-accordion]');

  if (!accordionRoot || accordionRoot.dataset.hashSyncBound === 'true') {
    return;
  }

  const hashValue = window.location.hash ? window.location.hash.slice(1) : '';
  const collapseFromHash = getCollapseElementFromHash(accordionRoot, hashValue);

  if (collapseFromHash) {
    openPanel(collapseFromHash);
  }

  accordionRoot.querySelectorAll('.accordion-collapse').forEach((collapseElement) => {
    collapseElement.addEventListener('show.bs.collapse', () => {
      const isAccordionSwitch = Boolean(
        accordionRoot.querySelector('.accordion-collapse.show, .accordion-collapse.collapsing:not(#' + escapeSelector(collapseElement.id) + ')')
      );

      collapseElement.dataset.scrollBehavior = isAccordionSwitch ? 'auto' : 'smooth';
    });

    collapseElement.addEventListener('shown.bs.collapse', () => {
      const parentItem = collapseElement.closest('.accordion-item');
      const anchorId = parentItem?.id || collapseElement.id;
      const scrollBehavior = collapseElement.dataset.scrollBehavior || 'smooth';

      if (anchorId) {
        window.history.replaceState({}, '', `#${anchorId}`);
      }

      if (!parentItem) {
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToAccordionHeader(parentItem, scrollBehavior);
          delete collapseElement.dataset.scrollBehavior;
        });
      });
    });
  });

  accordionRoot.dataset.hashSyncBound = 'true';
};